export enum TelemetryEvents {
	EcsClientStartFailed = 'FloodgateCore_ECSClient_Start_Failed',
}
